"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropKeys = dropKeys;
exports.pick = pick;
exports.qsStringify = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

function dropKeys(object, props) {
  var result = {};

  for (var i = 0, length = props.length; i < length; i++) {
    var prop = props[i];

    if (Object.prototype.hasOwnProperty.call(object, prop)) {
      result["".concat(prop)] = object[prop];
      delete object[prop];
    }
  }

  return result;
}

function pick(object, props) {
  var result = {};
  props.forEach(function (prop) {
    if (Object.prototype.hasOwnProperty.call(object, prop)) {
      result["".concat(prop)] = object[prop];
    }
  });
  return result;
}

var qsStringify = function qsStringify(obj) {
  var objEntries = Object.entries(obj);
  return objEntries.reduce(function (cur, item, index) {
    var _item = (0, _slicedToArray2.default)(item, 2),
        key = _item[0],
        value = _item[1];

    cur += "".concat(key, "=").concat(value).concat(index !== objEntries.length - 1 ? '&' : '');
    return cur;
  }, '');
};

exports.qsStringify = qsStringify;